import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';
const URL_BASE_MONITOREO = BASE_URL;

const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');

    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

export const obtenerConfiguracionDet = async (codConfCab) => {
    try {
        const response = await axios.get(
            `${URL_BASE_MONITOREO}/configuracion/configuracion-det/configuracion-cab/codigo/${codConfCab}`,
            obtenerConfig()
        );
        return response.data.data;
    } catch (error) {
        console.error('Error:', error.message);
        throw new Error('Error al consultar configuracion');
    }
};

export const obtenerConfigByCabCodigo = async (cabCodigo) => {
    try {
        const response = await axios.get(
            `${URL_BASE_MONITOREO}/simpleConfiguracionDet/configCabCode/${cabCodigo}`,
            obtenerConfig()
        );
        return response.data;
    } catch (error) {
        console.error('Error:', error.message);
        throw new Error('Error al consultar configuracion por cabecera');
    }
};

export const obtenerConfigByCabCodigoNoAwait = (cabCodigo) => {
    return axios
        .get(
            `${URL_BASE_MONITOREO}/simpleConfiguracionDet/configCabCode/${cabCodigo}`,
            obtenerConfig()
        )
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error:', error.message);
            throw new Error('Error al consulta configuracion por cabecera');
        });
};

export const obtenerConfigByCodigo = async (codigoConfigDet) => {
    try {
        const response = await axios.get(`${BASE_URL}/simpleConfiguracionDet/${codigoConfigDet}`, obtenerConfig())
        return response.data
    } catch (error) {
        
    }
}